/**
 * The user-facing label for a signed-in user. Prefers `displayName` when set;
 * falls back to email. Trim guards against accidental whitespace-only names —
 * we treat those as "no name" rather than showing a blank label.
 */
export function userLabel(user: { displayName: string | null; email: string | null }): string {
  const name = user.displayName?.trim();
  if (name) return name;
  return user.email ?? "";
}
